import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  selectionHeading: {
    color: theme.palette.black.main,
    fontSize: '14px',
    textAlign: 'left',
    margin: theme.spacing(1.75, 0, 2, 0),
  },
  container: {
    marginTop: theme.spacing(6),
  },
  root: {
    marginTop: theme.spacing(3),
    textAlign: 'left',
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(4, 0, 2, 0),
  },
  subHeadingContainerMicrosoft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(0, 0, 2, 0),
  },
  subHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginRight: theme.spacing(1.125),
  },
  labelText: {
    color: theme.palette.black.main,
    fontSize: '14px',
    textAlign: 'left',
    margin: theme.spacing(1.75, 0, 2, 0),
  },
  description: {
    flexGrow: 1,
  },
}))
